import React, { useCallback, useEffect } from "react";

import ACL_RELATIONSHIPS from "acl-relationships";
import { getNextQueryParams } from "components/helpers";
import withRoleCheck from "components/hocs/withRoleCheck";
import BaseTableV3 from "components/BaseTableV3/BaseTableV3";
import _SmtpAccountModal from "routes/smtp_accounts/SmtpAccountModal";
import setPageTitle from "helpers/title";
import SmtpAccountService from "services/SmtpAccounts";
import {
  invalidateSmtpAccountsQuery,
  useSmtpAccountsTable,
} from "hooks/useSmtpAccountsTable";

export const SMTP_ACCOUNTS_TABLE_CONSTANTS = {
  tableName: "smtp_accounts",
  queryKey: "smtp-accounts",
  className: "smtp_accounts",
  exportTableName: null,
  header: "SMTP Accounts",
  headerIcon: "mail",
};

const SmtpAccountModal = withRoleCheck(_SmtpAccountModal, [
  ACL_RELATIONSHIPS.emailConfigSmtp.create,
]);

const SmtpAccountsTableV3 = () => {
  const { columns } = useSmtpAccountsTable();

  const fetchSmtpAccounts = useCallback(
    async queryParams => {
      try {
        const nextQueryParams = getNextQueryParams(queryParams, columns);

        const response = await SmtpAccountService.getSmtpAccountsTable(
          nextQueryParams
        );

        return response;
      } catch (error) {
        console.error("Error fetching smtp accounts:", error);
        throw error;
      }
    },
    [columns]
  );

  useEffect(() => {
    setPageTitle("SMTP Accounts");
  }, []);

  return (
    <BaseTableV3
      columns={columns}
      queryKey={SMTP_ACCOUNTS_TABLE_CONSTANTS.queryKey}
      className={SMTP_ACCOUNTS_TABLE_CONSTANTS.className}
      tableName={SMTP_ACCOUNTS_TABLE_CONSTANTS.tableName}
      headerIcon={SMTP_ACCOUNTS_TABLE_CONSTANTS.headerIcon}
      header={SMTP_ACCOUNTS_TABLE_CONSTANTS.header}
      createButton={
        <SmtpAccountModal onSuccess={invalidateSmtpAccountsQuery} />
      }
      fetchData={fetchSmtpAccounts}
      invalidateData={invalidateSmtpAccountsQuery}
      enableSettings
    />
  );
};

export default SmtpAccountsTableV3;
